import React, { useEffect, useState } from 'react'
import { FilterList } from 'src/components/CustomInputs/FilterList'
import CustomSortSelect from 'src/components/CustomInputs/CustomSortSelect'
import { useTranslation } from 'react-i18next'
import { ColoredFilterList } from 'src/components/CustomInputs/ColorFilterList'
import useQueryParam from './useQueryParams'
import { subLinksApparel } from 'src/components/Navigation/Sublinks/apparel'
import { subLinksCollection } from 'src/components/Navigation/Sublinks/collections'
import { subLinksHeadwear } from 'src/components/Navigation/Sublinks/headwear'
import { navigationLinks } from 'src/components/Navigation/Sidebar'

export const useFilter = allShopifyProduct => {
  const pathname =
    typeof document !== 'undefined' &&
    document.location.pathname.replace(/\/de\/|\/en\/|\/fr\//, '/')

  const [styleFilter, setStyleFilter] = useState(['all'])
  const [colorFilter, setColorFilter] = useState(['all'])
  const [sizeFilter, setSizeFilter] = useState(['all'])
  const [collectionFilter, setCollectionFilter] = useState(['all'])
  const [promotionsFilter, setPromotionsFilter] = useState(['all'])
  const [sorting, setSorting] = useState('default')
  const { t } = useTranslation('productFilters')
  const [styleFilterValues, setStyleFilterValues] = useState(['all'])
  const [sizeFilterValues, setSizeFilterValues] = useState(['all'])
  const [collectionFilterValues, setCollectionFilterValues] = useState(['all'])
  const [promotionsFilterValues, setPromotionsFilterValues] = useState(['all'])
  const [colorFilterValues, setColorFilterValues] = useState([
    { id: 99, label: 'All', value: 'all' },
    { id: 100, label: 'Red', value: 'red' },
  ])

  const [styleQuery, setStyleQuery] = useQueryParam('types', '')
  const [colorQuery, setColorQuery] = useQueryParam('colors', '')
  const [sizeQuery, setSizeQuery] = useQueryParam('sizes', '')
  const [collectionQuery, setCollectionQuery] = useQueryParam('collections', '')
  const [promotionsQuery, setPromotionsQuery] = useQueryParam('promotions', '')

  const priceAscendingLabel = t('productFilters.sortBy.priceAscending')
  const priceDescendingLabel = t('productFilters.sortBy.priceDescending')
  const sortByLatestLabel = t('productFilters.sortBy.latest')

  const [sortingValues] = useState([
    { id: 102, label: sortByLatestLabel, value: 'default' },
    { id: 103, label: priceDescendingLabel, value: 'highToLow' },
    { id: 104, label: priceAscendingLabel, value: 'lowToHigh' },
  ])

  const setFilterWithQuery = (setQuery, setFilter, value) => {
    setQuery(value.join())
    setFilter(value)
  }

  useEffect(() => {
    styleQuery && setStyleFilter(styleQuery.split(','))
    colorQuery && setColorFilter(colorQuery.split(','))
    sizeQuery && setSizeFilter(sizeQuery.split(','))
    collectionQuery && setCollectionFilter(collectionQuery.split(','))
    promotionsQuery && setPromotionsFilter(promotionsQuery.split(','))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getStyleFilterValuesFromProducts()
    getSizeFilterValuesFromProducts()
    getColorFilterValues()
    getCollectionFilterValues()
    getPromotionsFilterValues()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allShopifyProduct])

  const getColorFilterValues = () => {
    let tmpColors
    if (
      allShopifyProduct &&
      allShopifyProduct[0] &&
      allShopifyProduct[0].node &&
      allShopifyProduct[0].node.metafields[0] &&
      allShopifyProduct[0].node.metafields[0].key &&
      allShopifyProduct[0].node.metafields[0].value
    ) {
      tmpColors = allShopifyProduct.map(e => {
        let colors = e.node.metafields.map(field => {
          if (field.key === 'color') return field.value
          else return null
        })
        return colors.filter(e => e !== undefined)
      })

      if (tmpColors.length < 1) return [{ id: 9999, label: 'All', value: 'all' }]

      tmpColors = tmpColors.flat()
      tmpColors = new Set([...tmpColors])
      tmpColors = [...tmpColors]
      const colorOptions = tmpColors.map((color, index) => {
        return { id: index, label: color, value: color }
      })

      const sortedColorOptions = colorOptions.sort((a, b) => {
        return a.label > b.label ? 1 : -1
      })

      const multicolorIndex = sortedColorOptions.findIndex(
        colorOption => colorOption.label === 'Multicolor'
      )
      if (multicolorIndex >= 0) {
        const multiColor = sortedColorOptions.splice(multicolorIndex, 1)
        sortedColorOptions.push(...multiColor)
      }
      setColorFilterValues(sortedColorOptions)
    } else setColorFilterValues([{ id: 999, label: 'All', value: 'all' }])
  }

  const getPromotionsFilterValues = () => {
    setPromotionsFilterValues([
      { id: 998, label: 'New-In', value: 'newIn' },
      { id: 999, label: 'Sale', value: 'Sale' },
    ])
  }

  const getCollectionFilterValues = () => {
    // The order here is also the displayed order in the filtersection
    const collections = [
      'Maus & Friends',
      'Långstrump',
      'ESA',
      'Peanuts',
      'Captain Tsubasa',
      'Eintracht Frankfurt',
      'Hamburger SV',
      'NFL',
      'Astérix',
      'Lucky Luke',
      'Bibi & Benjamin',
      'L&L Originals',
      'Local',
    ]

    const sortedCollections = {}

    for (let i = 1; i <= collections.length; i++) {
      sortedCollections[collections[i - 1]] = i
    }
    sortedCollections['default'] = 999

    if (
      allShopifyProduct &&
      allShopifyProduct[0] &&
      allShopifyProduct[0].node &&
      allShopifyProduct[0].node.metafields[0] &&
      allShopifyProduct[0].node.metafields[0].key &&
      allShopifyProduct[0].node.metafields[0].value
    ) {
      const uniqueFilterValues = allShopifyProduct.map(e => {
        let collections = e.node.metafields.map(field => {
          if (field.key === 'collection') return field.value
          else return null
        })
        return collections.filter(e => e !== undefined)
      })

      let flatFilter = new Set(uniqueFilterValues.flat())
      let filterOptions = [...flatFilter]

      filterOptions = filterOptions.map((element, index) => {
        if (element === '' || element === null || element === undefined || element === '—')
          return null
        return { id: index, label: element, value: element }
      })
      filterOptions = filterOptions.filter(e => e != null)

      const sortedFilterOptions = filterOptions.sort((a, b) => {
        return (
          (sortedCollections[a.value] || sortedCollections.default) -
          (sortedCollections[b.value] || sortedCollections.default)
        )
      })

      setCollectionFilterValues([...sortedFilterOptions])
    }
  }

  const getStyleFilterValuesFromProducts = () => {
    if (allShopifyProduct && allShopifyProduct[0] && allShopifyProduct[0].node) {
      let tmpTypes = allShopifyProduct.map(e => {
        let types = e.node.metafields.map(field => {
          if (field.key === 'productType') return field.value
          else return null
        })
        return types.filter(e => e !== undefined)
      })

      if (tmpTypes.length < 1) return [{ id: 9999, label: 'All', value: 'all' }]

      tmpTypes = tmpTypes.flat()
      tmpTypes = new Set([...tmpTypes])
      tmpTypes = [...tmpTypes]
      const typeOptions = tmpTypes.map((type, index) => {
        return { id: index, label: type, value: type }
      })
      setStyleFilterValues(typeOptions.sort((a, b) => (a.label > b.label ? 1 : -1)))
    } else setStyleFilterValues([{ id: 999, label: 'All', value: 'all' }])
  }

  const getSizeFilterValuesFromProducts = () => {
    let uniqueFilterValues
    if (
      allShopifyProduct &&
      allShopifyProduct[0] &&
      allShopifyProduct[0].node &&
      allShopifyProduct[0].node.options[0] &&
      allShopifyProduct[0].node.options[0].values
    ) {
      if (colorFilter.includes('all')) {
        uniqueFilterValues = new Set(
          allShopifyProduct.map(e => {
            const sizes = e.node.options.find(e => e.name === 'Größe' || e.name === 'Size')
            if (sizes !== undefined) {
              return [...sizes.values]
            } else {
              const sizeMetafield = e.node.metafields.find(field => field.key === 'size')
              if (sizeMetafield && sizeMetafield.value) return [sizeMetafield.value]
              return null
            }
          })
        )
      } else {
        uniqueFilterValues = new Set(
          allShopifyProduct.map(product => {
            if (product.node.metafields.some((r, i) => colorFilter.includes(r.value))) {
              const sizes = product.node.options.find(e => e.name === 'Größe')
              if (sizes !== undefined) {
                return [...sizes.values]
              } else return [product.node.metafields.find(field => field.key === 'size').value]
            } else return null
          })
        )
      }

      uniqueFilterValues = [...uniqueFilterValues].filter(e => e !== undefined && e !== null)

      uniqueFilterValues.map((e, index) => {
        if (index === 0) uniqueFilterValues = [...e]
        else uniqueFilterValues = [...uniqueFilterValues, ...e]
        return null
      })

      const uniqueFilterValuesArray = new Set(uniqueFilterValues)

      let filterOptions = [...uniqueFilterValuesArray]
      filterOptions = filterOptions.map((element, index) => {
        if (element === '' || element === null || element === undefined) return null
        return { id: index, label: element, value: element }
      })
      filterOptions = filterOptions.filter(e => e != null)

      setSizeFilterValues([...filterOptions])
    } else {
      setSizeFilterValues([{ id: 1, label: 'All', value: 'all' }])
    }
  }

  const removeFilterValue = value => {
    if (styleFilter.includes(value)) {
      const newFilterValues = styleFilter.filter(filterValue => filterValue !== value)
      if (newFilterValues.length === 0) {
        setStyleFilter(['all'])
        setStyleQuery('')
      } else {
        setStyleFilter(newFilterValues)
        setStyleQuery(newFilterValues.join())
      }
    } else {
      if (colorFilter.includes(value)) {
        const newFilterValues = colorFilter.filter(filterValue => filterValue !== value)
        if (newFilterValues.length === 0) {
          setColorFilter(['all'])
          setColorQuery('')
        } else {
          setColorFilter(newFilterValues)
          setColorQuery(newFilterValues.join())
        }
      } else {
        if (sizeFilter.includes(value)) {
          const newFilterValues = sizeFilter.filter(filterValue => filterValue !== value)
          if (newFilterValues.length === 0) {
            setSizeFilter(['all'])
            setSizeQuery('')
          } else {
            setSizeFilter(newFilterValues)
            setSizeQuery(newFilterValues.join())
          }
        } else {
          if (collectionFilter.includes(value)) {
            const newFilterValues = collectionFilter.filter(filterValue => filterValue !== value)
            if (newFilterValues.length === 0) {
              setCollectionFilter(['all'])
              setCollectionQuery('')
            } else {
              setCollectionFilter(newFilterValues)
              setCollectionQuery(newFilterValues.join())
            }
          } else {
            if (promotionsFilter.includes(value)) {
              const newFilterValues = promotionsFilter.filter(filterValue => filterValue !== value)
              if (newFilterValues.length === 0) {
                setPromotionsFilter(['all'])
                setPromotionsQuery('')
              } else {
                setPromotionsFilter(newFilterValues)
                setPromotionsQuery(newFilterValues.join())
              }
            }
          }
        }
      }
    }
  }

  const clearAllFilters = () => {
    const allFilterValuesValue = ['all']
    setStyleFilter(allFilterValuesValue)
    setStyleQuery('')
    setColorFilter(allFilterValuesValue)
    setColorQuery('')
    setSizeFilter(allFilterValuesValue)
    setSizeQuery('')
    setCollectionFilter(allFilterValuesValue)
    setCollectionQuery('')
    setPromotionsFilter(allFilterValuesValue)
    setPromotionsQuery('')
  }

  const SortDropdown = (
    <CustomSortSelect
      setValue={setSorting}
      name={'sortingDropdown'}
      defaultText={sortByLatestLabel}
      optionsList={sortingValues}
    />
  )

  const StyleFilterList = !Object.values({
    ...subLinksApparel,
    ...subLinksHeadwear,
  }).includes(pathname) && (
    <FilterList
      title={t('productFilters.style')}
      setSelectedFilters={value => setFilterWithQuery(setStyleQuery, setStyleFilter, value)}
      selectedFilters={styleFilter}
      options={styleFilterValues}
    />
  )

  const CollectionFilterList = !Object.values(subLinksCollection).includes(pathname) && (
    <FilterList
      title={t('productFilters.collections')}
      setSelectedFilters={value =>
        setFilterWithQuery(setCollectionQuery, setCollectionFilter, value)
      }
      selectedFilters={collectionFilter}
      options={collectionFilterValues}
      showMoreList={true}
    />
  )

  const ColorFilterList = (
    <ColoredFilterList
      title={t('productFilters.color')}
      setSelectedFilters={value => setFilterWithQuery(setColorQuery, setColorFilter, value)}
      selectedFilters={colorFilter}
      options={colorFilterValues}
    />
  )
  const ColorFilterListMobile = (
    <ColoredFilterList
      title={t('productFilters.color')}
      setSelectedFilters={value => setFilterWithQuery(setColorQuery, setColorFilter, value)}
      selectedFilters={colorFilter}
      options={colorFilterValues}
      isMobile={true}
    />
  )

  const PromotionsFilterList = !Object.values(navigationLinks).includes(pathname) && (
    <FilterList
      title={t('productFilters.promotions')}
      setSelectedFilters={value =>
        setFilterWithQuery(setPromotionsQuery, setPromotionsFilter, value)
      }
      selectedFilters={promotionsFilter}
      options={promotionsFilterValues}
    />
  )

  const SizeFilterList = (
    <FilterList
      title={t('productFilters.size')}
      setSelectedFilters={value => setFilterWithQuery(setSizeQuery, setSizeFilter, value)}
      selectedFilters={sizeFilter}
      options={sizeFilterValues}
    />
  )

  const SizeFilterListMobile = (
    <FilterList
      title={t('productFilters.size')}
      setSelectedFilters={value => setFilterWithQuery(setSizeQuery, setSizeFilter, value)}
      selectedFilters={sizeFilter}
      options={sizeFilterValues}
      isMobile={true}
    />
  )

  const selectedFilterCount =
    styleFilter.filter(filter => filter !== 'all').length +
    colorFilter.filter(filter => filter !== 'all').length +
    sizeFilter.filter(filter => filter !== 'all').length +
    collectionFilter.filter(filter => filter !== 'all').length +
    promotionsFilter.filter(filter => filter !== 'all').length

  const allFilterValues = [
    ...styleFilter.filter(filter => filter !== 'all'),
    ...colorFilter.filter(filter => filter !== 'all'),
    ...sizeFilter.filter(filter => filter !== 'all'),
    ...collectionFilter.filter(filter => filter !== 'all'),
    ...promotionsFilter.filter(filter => filter !== 'all'),
  ]

  return {
    selectedFilterCount,
    styleFilter,
    colorFilter,
    sizeFilter,
    collectionFilter,
    promotionsFilter,
    sorting,
    SortDropdown,
    CollectionFilterList,
    StyleFilterList,
    ColorFilterList,
    ColorFilterListMobile,
    SizeFilterList,
    SizeFilterListMobile,
    PromotionsFilterList,
    allFilterValues,
    removeFilterValue,
    clearAllFilters,
  }
}
